import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import DataLayer, { Layout } from './dataLayer';
/**
 * Tests current experience against provided experience
 *
 * @param {Layout} experienceName - The experience name to test current experience against
 * @returns {Promise<boolean>}
 */
const testExperience = async (experienceName) => {
    try {
        const user = await DataLayer.get('visitor');
        const { layout } = user;
        return layout === experienceName;
    }
    catch (e) {
        Logger.error(e);
        return false;
    }
};
/**
 * Determines if current experience is MobileWeb
 *
 * @returns {boolean}
 */
export const isMobile = async () => testExperience(Layout.MobileWeb);
